<div class="view-tools">
  <ng-container *ngIf="mode === viewToolsMode.Main">

    <!-- Media Controls -->
    <ng-container *ngIf="(isChapterAnimated$ | async) && isEnabled(viewLayout.Media)">
      <!-- Play -->
      <app-pin-button
        type="ghost"
        size="small"
        class="view-tools__item"
        [label]="(animationPlaying$ | async) ? 'Pause' : 'Play'"
        [icon]="(animationPlaying$ | async) ? 'pause' : 'play'"
        (click)="handlePlayClick()"
      ></app-pin-button>

      <!-- Open Media Bar -->
      <app-pin-button
        type="ghost"
        size="small"
        class="view-tools__item"
        label="Scrub"
        (mousedown)="toggleToolbar('media')">
        <app-view-scrubber [showHandle]="false" style="width: 16px"></app-view-scrubber>
      </app-pin-button>
    
      <div class="view-tools__divider"></div>
    </ng-container>


    <!-- Tools Toggle -->
    <app-pin-button
      *ngIf="isEnabled(viewLayout.Tools)"
      type="ghost"
      size="small"
      class="view-tools__item"
      label="Tools"
      (click)="toggleToolbar('tools')"
      icon="pen"
    ></app-pin-button>

    <!-- Search Toggle -->
    <app-pin-button
      *ngIf="isEnabled(viewLayout.Search)"
      type="ghost"
      size="small"
      class="view-tools__item"
      label="Search"
      icon="search"
      (click)="handleSearchClick()"
    ></app-pin-button>

    <!-- Fulscreen Toggle -->
    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      label="Expand"
      (click)="handleFullscreenClick()"
      icon="expand"
      *ngIf="canFullscreen && isEnabled(viewLayout.Fullscreen)"
    ></app-pin-button>

    <!-- New Tab Toggle -->
    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      label="New Tab"
      (click)="handleNewTabClick()"
      icon="external-link"
      *ngIf="!canFullscreen && isEnabled(viewLayout.Fullscreen)"
    ></app-pin-button>

    <!-- More Toggle -->
    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      label="More"
      icon="ellipsis-v"
      [matMenuTriggerFor]="moreMenu"
    ></app-pin-button>
  </ng-container>


  <!-- Submenu: Scrubber -->
  <ng-container *ngIf="mode === viewToolsMode.Media && isEnabled(viewLayout.Media)">
    <!-- Play -->
    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      [label]="(animationPlaying$ | async) ? 'Pause' : 'Play'"
      [icon]="(animationPlaying$ | async) ? 'pause' : 'play'"
      (click)="handlePlayClick()"
    ></app-pin-button>

    <div style="width: 200px">
      <app-view-scrubber></app-view-scrubber>
    </div>
  </ng-container>

  <!-- Submenu: Tools   -->
  <ng-container *ngIf="mode === viewToolsMode.Tools">
    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      label="Select"
      icon="mouse-pointer"
      [selected]="(activeTool$ | async) === toolEnum.Select"
      (click)="handleSelectTool(toolEnum.Select)">
    </app-pin-button>

    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      label="Hide"
      icon="eye-slash"
      [selected]="(activeTool$ | async) === toolEnum.Hide"
      (click)="handleSelectTool(toolEnum.Hide)">
    </app-pin-button>
    
    <app-pin-button
      appHideIE11
      type="ghost"
      size="small"
      class="view-tools__item"
      label="Fade"
      icon="adjust"
      [selected]="(activeTool$ | async) === toolEnum.Fade"
      (click)="handleSelectTool(toolEnum.Fade)">
    </app-pin-button>

    <div class="view-tools__divider"></div>

    <app-pin-button
      type="ghost"
      size="small"
      class="view-tools__item"
      [disabled]="(activeTool$ | async) !== toolEnum.Hide"
      label="Undo"
      icon="undo"
      (click)="handleUndoClick()">
    </app-pin-button>
    
  </ng-container>
</div>


<!-- More Menu -->
<mat-menu #moreMenu="matMenu">
  <!-- Help -->
  <button mat-menu-item (click)="handleHelpClick()" *ngIf="isEnabled(viewLayout.Help)">
    Help
  </button>

  <!-- Toggles -->
  <button mat-menu-item (click)="handleToggleLabelsClick()" [disabled]="!(labels$ | async)?.length">
    <ng-container *ngIf="showLabels$ | async">Hide labels</ng-container>
    <ng-container *ngIf="!(showLabels$ | async)">Show labels</ng-container>
  </button>
</mat-menu>
